export default __webpack_public_path__ + "static/media/006-dolphin.763b892e.png";